module.exports = __webpack_public_path__ + "img/17.839814fc.jpg";